import { defineStore } from 'pinia'
import { uuid } from 'vue3-uuid'
import { APIClient } from '@/onenetwork/core/onenetwork.api.instant'
import { reactive } from 'vue'
import { CONTRACT_API } from '@/modules/contract/constants/contract.api.uri.const.ts'

export enum ContractDetailActionType {
  FETCHING = 'fetching',
  FETCHED = 'fetched',
  FETCH_FAILED = 'fetch_failed',
  CREATING = 'creating',
  CREATED = 'created',
  CREATE_FAILED = 'create_failed',
  UPDATING = 'updating',
  APPROVING = 'approving',
  APPROVED = 'approved',
  APPROVE_FAILED = 'approve_failed',
  REJECTING = 'rejecting',
  REJECTED = 'rejected',
  REJECT_FAILED = 'reject_failed',
}

interface ContractDetail {
  id: number
  code: string
  fullname: string
  phone: string
  email: string
  status: string
  profile_pic: string | null
  created_at: string
  updated_at: string
  role: object
  perms: string[]
}

interface ContractDetailState {
  contracts: {
    [key: string]: {
      action_type: ContractDetailActionType,
      approve_type: ContractDetailActionType,
      action_message: string,
      contract: ContractDetail
    }
  }
}

export const useContractDetailStore = defineStore('contract.detail', {
  state: (): ContractDetailState => ({
    contracts: {},
  }),
  getters: {},
  actions: {
    fetchDetail(contractId: number): Promise<ContractDetail> {
      return new Promise(async (resolve, reject) => {
        const detailItem = this.contracts[contractId] || {
          action_type: ContractDetailActionType.FETCHING,
          action_message: null,
          contract: null
        }
        try{
          const res = await APIClient.get(CONTRACT_API+'/'+contractId)

          detailItem.contract = res?.data?.data
          detailItem.action_type = ContractDetailActionType.FETCHED
          this.contracts[contractId] = detailItem
          resolve(res?.data?.data)
        } catch (e: any) {
          detailItem.action_type = ContractDetailActionType.FETCH_FAILED
          reject(e)
        }
      })
    }
  },
})
